import API from 'app/services/group/groupApi'
import { GroupModel } from 'app/models/groupModel'
import { CreateGroupModel } from 'app/models/createGroupModel'
import { AddCompanyToGroupModel } from 'app/models/addCompanyToGroupModel'
import { RemoveCompanyFromGroupModel } from 'app/models/removeCompaniesFromGroups'

/**
 * Grupy firm, wspólne dla siedmiu ekranów panelu (grupy, użytkownicy, raporty,
 * komunikaty, edycja firmy, edycja użytkownika, modal wydruku grupowego).
 *
 * Slice `groups` trzymał JEDNĄ listę bez względu na `tenantId` - kolejne pobranie
 * po prostu ją nadpisywało. Zachowujemy to: jeden klucz, a `tenantId` jest tylko
 * parametrem zapytania. Inaczej dwa ekrany z różnym tenantem widziałyby dwie listy,
 * a wcześniej widziały tę samą.
 */
export const GROUPS_KEY = ['admin', 'groups'] as const

/** Mapowanie przeniesione 1:1 z thunka. */
export const mapGroupFields = (data: any): GroupModel => ({
  id: data.id,
  name: data.name,
  companies: data.companies,
})

export const fetchGroups = async (tenantId?: string): Promise<GroupModel[]> => {
  const response = await API.create().getGroups(tenantId)
  return (response.content.data as any[]).map(mapGroupFields)
}

export const addGroupRequest = async (
  group: CreateGroupModel,
): Promise<GroupModel> => {
  const response = await API.create().addGroup(group)
  return mapGroupFields(response.content.data)
}

export const deleteGroupsRequest = (ids: Array<number>, tenantId?: string) =>
  API.create().deleteGroups(ids, tenantId)

export const addCompanyToGroupsRequest = async (
  input: AddCompanyToGroupModel,
): Promise<GroupModel[]> => {
  const response = await API.create().addCompanyToGroups(input)
  return (response.content.data as any[]).map(mapGroupFields)
}

export const removeCompanyFromGroupsRequest = async (
  input: RemoveCompanyFromGroupModel,
): Promise<GroupModel[]> => {
  const response = await API.create().removeCompanyFromGroups(input)
  return (response.content.data as any[]).map(mapGroupFields)
}

/** Kształt błędu, którego oczekują komponenty (sprawdzają `.error`). */
export const toActionError = (error: unknown) => ({
  error: (error as any)?.status?.data?.code,
})
